function adjustGridItemHeights() {
  const gridItems = document.querySelectorAll('#main-collection-product-grid .product-item');
  let maxHeight = 0;

  // Reset height to auto before calculating
  gridItems.forEach(item => {
    item.style.height = 'auto';
  });

  // Find the maximum height
  gridItems.forEach(item => {
    maxHeight = Math.max(maxHeight, item.offsetHeight);
  });

  // Set all items to the maximum height
  gridItems.forEach(item => {
    item.style.height = `${maxHeight}px`;
  });
}

// Run on load
window.addEventListener('load', adjustGridItemHeights);

// Run on resize
window.addEventListener('resize', adjustGridItemHeights);

function updateFilterText() {
    // Select all elements with the class text-size--small
    const filterElements = document.querySelectorAll('form#FacetFiltersForm .text-size--small, form#FacetFiltersFormMobile .text-size--small');
    
    filterElements.forEach(element => {
        // Remove the count in parentheses from the text
        element.textContent = element.textContent.replace(/\s\(\d+\)$/, '');
    });
}

// Run the function on initial load
document.addEventListener('DOMContentLoaded', () => {
    updateFilterText();
});

// Run the function on window resize
window.addEventListener('resize', () => {
    updateFilterText();
});


  


